/* tslint:disable */
/* eslint-disable */
/**
 * IGA Gewinnspiel API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: info@wapp.gmbh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringWrapper
 */
export interface StringWrapper {
    /**
     * 
     * @type {string}
     * @memberof StringWrapper
     */
    text: string;
}

export function StringWrapperFromJSON(json: any): StringWrapper {
    return StringWrapperFromJSONTyped(json, false);
}

export function StringWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function StringWrapperToJSON(value?: StringWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
    };
}


